import {z} from 'zod';
import {baseCardSchema} from '../../../../schemas/baseSchemas';
import {DTNode} from 'common/src/modules/decisionTree/decisionTree.types';

export function getAICardBaseDetails(
  card: z.input<typeof baseCardSchema>,
): Pick<DTNode, 'id' | 'name' | 'description'> & {name?: string; description?: string} {
  return {
    id: card.cardId,
    ...(card.name && {name: card.name}),
    ...(card.description && {description: card.description}),
  };
}
